/** Ürün ve kategori SSS metni. Sunucudaki şema aynı dil dosyasını okur. */

export function productFaqItems(product, t) {
  if (!product?.name || typeof t !== 'function') return [];
  const stock = Number(product.stock) || 0;
  const currency = String(product.currency || 'TRY').toUpperCase();
  const ship = product.shipping_cost;
  const shipAnswer =
    ship === undefined || ship === null || ship === ''
      ? t('search.faqShipUnknown', 'Kargo ücreti ürün sayfasında ve sepette ayrıca gösterilir.')
      : t('search.faqShipKnown', 'Bu ilan için kargo ücreti {{cost}} {{currency}}.', {
          cost: ship,
          currency,
        });
  return [
    {
      question: t('search.faqStockQ', '{{name}} stokta var mı?', { name: product.name }),
      answer:
        stock > 0
          ? t('search.faqStockYes', 'Evet, bu ilan stokta görünüyor.')
          : t('search.faqStockNo', 'Bu ilan şu an stokta görünmüyor.'),
    },
    {
      question: t('search.faqReturnQ', 'İade süresi ne kadar?'),
      answer: t('search.faqReturnA', 'Sipariş tesliminden sonra 14 gün içinde iade edilebilir.'),
    },
    {
      question: t('search.faqShipQ', 'Kargo bilgisi nedir?'),
      answer: shipAnswer,
    },
  ];
}

export function categoryFaqItems(name, total, t) {
  const label = (name || '').trim();
  if (!label || typeof t !== 'function') return [];
  const count = Number(total) || 0;
  const listing =
    count > 0
      ? t(
          'search.faqWhereCount',
          'Bu sayfa Turkish E-Market {{name}} kategorisindeki ilanları gösterir. Listede {{count}} ürün var.',
          { name: label, count },
        )
      : t(
          'search.faqWherePlain',
          'Bu sayfa Turkish E-Market {{name}} kategorisindeki ilanları gösterir.',
          { name: label },
        );
  return [
    {
      question: t('search.faqWhereQ', '{{name}} ürünleri nerede listelenir?', { name: label }),
      answer: listing,
    },
    {
      question: t('search.faqReturnQ', 'İade süresi ne kadar?'),
      answer: t('search.faqReturnA', 'Sipariş tesliminden sonra 14 gün içinde iade edilebilir.'),
    },
    {
      question: t('search.faqCompareQ', 'Fiyatlar nasıl karşılaştırılır?'),
      answer: t(
        'search.faqCompareA',
        'Sıralama ve fiyat filtresiyle aynı kategorideki ilanları yan yana görebilirsiniz.',
      ),
    },
  ];
}

export function faqPageJsonLd(items) {
  if (!items?.length) return '';
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  });
}
